import React from 'react';

function Tabs(props) {
  return (
    <div className="recharge-tabs-container">
      <div className="map-container-selector font10">
        <div
          className={'selector-item ' + (props.selectedTab == 1 ? 'active' : '')}
          onClick={() => props.onTabChange(1)}
        >
          {props.t('PROFILE.CASH')}
        </div>
        <div
          className={'selector-item ' + (props.selectedTab == 2 ? 'active' : '')}
          onClick={() => props.onTabChange(2)}
        >
          {props.t('PROFILE.BANK_TRANSFER')}
        </div>
      </div>
    </div>
  );
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/features/my-account/RechargeWalletKupospayRecharge/components/Tabs.js